import { useEffect, useState } from 'react';
import { getActiveSubscription } from 'services/user.service';

// session.user.subscription.featureSubscriptions is cached in the NextAuth JWT
// for the whole calendar day (checkUserSubscription in utils/billing.helper.js),
// so a business whose plan changed mid-session — an admin activating a custom
// plan, a cancellation processed elsewhere — keeps the pre-change snapshot
// until it signs in again. utils/requireFeatureAccess.js already re-checks live
// for the same reason on the SSR page gate; this is the client-side equivalent
// for anything that has to render the current state.
//
// Returns null until the live map is known, so callers can fall back to the
// cached session value rather than briefly rendering everything as locked. A
// failed request stays null for the same reason: a network hiccup must not
// lock a paying customer out of their own nav.
export function useLiveFeatureSubscriptions(userId) {
  const [featureSubscriptions, setFeatureSubscriptions] = useState(null);

  useEffect(() => {
    if (!userId) return undefined;

    let isCurrent = true;

    getActiveSubscription(userId)
      .then((response) => {
        if (isCurrent && response?.featureSubscriptions) {
          setFeatureSubscriptions(response.featureSubscriptions);
        }
      })
      .catch(() => {
        // Fall back to the cached session value — see above.
      });

    return () => {
      isCurrent = false;
    };
  }, [userId]);

  return featureSubscriptions;
}
